<template>
  <div class="mc-chips">
    <button
      v-for="opt in options"
      :key="opt"
      type="button"
      class="mc-chip"
      :class="{ 'is-on': isOn(opt) }"
      @click="toggle(opt)"
    >
      {{ opt }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'ChipGroup',
  props: {
    options: { type: Array, required: true },
    value: { type: [String, Array], default: '' },
    multi: { type: Boolean, default: false },
  },
  methods: {
    isOn(opt) {
      return this.multi ? this.value.includes(opt) : this.value === opt
    },
    toggle(opt) {
      if (this.multi) {
        const next = this.value.slice()
        const i = next.indexOf(opt)
        i >= 0 ? next.splice(i, 1) : next.push(opt)
        this.$emit('input', next)
      } else {
        this.$emit('input', this.value === opt ? '' : opt)
      }
    },
  },
}
</script>

<style scoped>
.mc-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.mc-chip {
  border: 1.5px solid #bdd8f5;
  background: #fff;
  color: #003087;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  padding: 9px 14px;
  border-radius: 999px;
  cursor: pointer;
  transition: 0.15s;
}

.mc-chip.is-on {
  background: #0066cc;
  border-color: #0066cc;
  color: #fff;
}
</style>
